import React from 'react';
import { Link } from 'react-router-dom';
import FundingLenderStatusBadge from './FundingLenderStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingLenderTable = ({ lenders, detailPathFor, loading }) => {
  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading lenders...</p>;
  if (!lenders?.length) return <p className="text-sm text-[var(--fg-muted)]">No lenders match the selected filters.</p>;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-sm">
        <thead>
          <tr className="border-b border-[var(--fg-line)] text-[var(--fg-muted)]">
            <th className="px-3 py-2">Lender</th>
            <th className="px-3 py-2">Type</th>
            <th className="px-3 py-2">Products</th>
            <th className="px-3 py-2">Criteria</th>
            <th className="px-3 py-2">Estimated speed</th>
            <th className="px-3 py-2">Status</th>
            <th className="px-3 py-2" />
          </tr>
        </thead>
        <tbody>
          {lenders.map((lender) => (
            <tr key={lender.id} className="border-b border-[var(--fg-line)]/70">
              <td className="px-3 py-3">
                <div className="font-medium text-[var(--fg-text)]">{lender.name}</div>
                {lender.isFeatured ? <div className="text-xs text-[var(--fg-accent)]">Featured</div> : null}
              </td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">{lender.type}</td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">
                {(lender.products || []).slice(0, 2).map((p) => p.productType || p).join(', ')}
                {(lender.products || []).length > 2 ? ` +${lender.products.length - 2}` : ''}
              </td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">
                {lender.minCreditScore ? `${lender.minCreditScore}+ credit` : '—'}
                <div className="text-xs">up to {formatCurrency(lender.maxRequestedAmount)}</div>
              </td>
              <td className="px-3 py-3 text-[var(--fg-muted)]">
                {lender.fundingSpeedDaysMin != null || lender.fundingSpeedDaysMax != null
                  ? `${lender.fundingSpeedDaysMin ?? '—'}-${lender.fundingSpeedDaysMax ?? '—'} days`
                  : '—'}
              </td>
              <td className="px-3 py-3"><FundingLenderStatusBadge status={lender.status} /></td>
              <td className="px-3 py-3 text-right">
                <Link
                  to={detailPathFor(lender.id)}
                  className="text-sm font-medium text-[var(--fg-accent)] hover:underline"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FundingLenderTable;
